import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { importHoldingsReducer, INTEGRATIONS_STATE_SLICE_KEY, } from 'IntegrationsApp/ts/features/integrations-shared/state/integrations-shared.reducer';
import { AccountIntegrationsModule } from 'AccountsApp/ts/apps/account-integrations-app/app.module';
import { SingleSelectDropdownModule } from 'Angular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { HelpModalModule } from 'Angular/features/components/modals/help-modal/help-modal.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { SimplePaginationControlsModule } from 'Angular/features/components/pagination/simple-pagination-controls/simple-pagination-controls.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { ImageModule } from 'Angular/features/directives/image/image.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { RefreshHoldingsModalModule } from 'IntegrationsApp/ts/features/refresh-holdings-modal/refresh-holdings-modal.module';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class IntegrationsSharedModule {
}
IntegrationsSharedModule.ɵfac = function IntegrationsSharedModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IntegrationsSharedModule)(); };
IntegrationsSharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: IntegrationsSharedModule });
IntegrationsSharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        DisabledModule,
        FormsModule,
        HelpModalModule,
        IconModule,
        ImageModule,
        LoadingSymbolModule,
        ModalBaseModule,
        RefreshHoldingsModalModule,
        SimplePaginationControlsModule,
        SingleSelectDropdownModule,
        AccountIntegrationsModule,
        TooltipModule,
        StoreModule.forFeature(INTEGRATIONS_STATE_SLICE_KEY, importHoldingsReducer)] });
